module.exports = function() {
    return {
        restrict: 'EA',
        replace: true,
        template: require('raw!shared/header.html'),
        controller: controller,
        controllerAs: 'headerCtrl',
        scope: {
          mainPage: '=',
          page: '=',
          slide: '='
        }
    }
}

function controller($scope, contentful, $uibModal, $uibModalStack, $window, $sce, $location, $document, store) {

  var vm = this;

  $scope.allWorkServicesProvided = []
    $scope.allWorkServicesTypes = []
  // $scope.allServices = []
  $scope.teamDropClosed = true
  $scope.workDropClosed = true
  $scope.newsDropClosed = true
  $scope.headerDivision = {
    'division': 'All'
  }
  $scope.serviceDropClosed = true

  if(store.get('selectedService')) {
    $scope.selectedService = store.get('selectedService')
  } else {
    $scope.selectedService = ''
  }
  if(store.get('selectedWorkService')) {
    $scope.selectedWorkService = store.get('selectedWorkService')
  } else {
    $scope.selectedWorkService = 'Building Enclosure'
  }
  if(store.get('currentDivision')) {
    $scope.headerDivision.current = store.get('currentDivision')
  } else {
    $scope.headerDivision.current = 'All'
  }
  $scope.setSelectedService = function (serviceProvided) {
    if(serviceProvided){
      store.set('selectedService', serviceProvided)
    } else {
      store.set('selectedService', $scope.defaultService)
    }
  }
  $scope.setWorkService = function (workService) {
    if(workService){
      store.set('selectedWorkService', workService)
    } else {
      store.set('selectedWorkService', $scope.defaultWorkService)
    }
  }
  $scope.setDivision = function (division) {
    store.set('currentDivision', division)
    $scope.slide = {
      'teamNav': true
    }
  }

  function comparePriority(a,b) {
  if (a.fields.priority < b.fields.priority)
    return -1;
  if (a.fields.priority > b.fields.priority)
    return 1;
  return 0;
  }
  contentful.entries('content_type=workProjects&include=3').then(function(res) {
    var workProjects = res.data.items
    $scope.allWorkProjects = res.data.items
    angular.forEach(workProjects, function(workProject){
      if(workProject.fields.services){
        var services = workProject.fields.services
        angular.forEach(services, function(service) {
          if(service.fields){
            var index = $scope.allWorkServicesProvided.indexOf(service)
            if (index < 0) {
              $scope.allWorkServicesProvided.push(service)
              $scope.allWorkServicesProvided.sort(comparePriority)
              $scope.defaultWorkService = $scope.allWorkServicesProvided[0]
              store.set('defaultWorkService', $scope.defaultWorkService)
            }
          }
        })
      }
    })
  })
  // contentful.entries('content_type=serviceTypes&include=3').then(function(res) {
  //   $scope.serviceTypes = res.data.items;
  // })
  $scope.allServices = []

  contentful.entries('content_type=serviceTypes').then(function(res) {
    var items = res.data.items
    angular.forEach(items, function(item){
      $scope.allServices.push(item)
      $scope.allServices.sort(comparePriority)
    })
    $scope.defaultService = $scope.allServices[0]
    store.set('defaultService', $scope.defaultService)
    // console.log('all services',   $scope.defaultService);
  })
  contentful.entries('content_type=topics').then(function(res) {
    $scope.allTags = res.data.items;
  })

};



/** WEBPACK FOOTER **
 ** ./components/shared/header.js
 **/